import { Fragment, useMemo, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import ExpandedSection from '@components/ExpandedSection';
import { useTranslation } from '@hooks';
import { googleLocationKey } from './filter';

const ExpandedSectionWrapper = styled(ExpandedSection)({
    marginBottom: '16px',
});

const GoogleLocationsGroups = ({ filter, renderLocation }) => {
    const { t } = useTranslation();
    const [collapsed, setCollapsed] = useState({ query: filter.query, sections: {} });
    const closedSections = collapsed.query === filter.query ? collapsed.sections : {};

    const toggleSection = accountName =>
        setCollapsed({
            query: filter.query,
            sections: { ...closedSections, [accountName]: !closedSections[accountName] },
        });

    const groups = useMemo(
        () => Object.entries(Object.groupBy(filter.visibleLocations, l => l.accountName)),
        [filter.visibleLocations],
    );

    if (!filter.hasLocations) return null;

    const emptyMessage = !filter.matchingLocations.length && (
        <Typography variant="body2" sx={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
            {t(filter.allConnectedHidden ? 'GoogleLocationsList.allConnected' : 'GoogleLocationsList.noMatches')}
        </Typography>
    );

    return (
        <>
            {emptyMessage}
            {groups.map(([accountName, items]) => (
                <ExpandedSectionWrapper
                    key={accountName}
                    isOpen={!closedSections[accountName]}
                    onClick={() => toggleSection(accountName)}
                    text={accountName}
                >
                    <div style={{ display: 'grid', gridGap: '8px' }}>
                        {items.map(l => (
                            <Fragment key={googleLocationKey(l)}>{renderLocation(l)}</Fragment>
                        ))}
                    </div>
                </ExpandedSectionWrapper>
            ))}
        </>
    );
};

export default GoogleLocationsGroups;
